import React from 'react';
import Navbar from "./Router";
import setBodyColor from './js/setBodyColor';
import setButtonColor from './js/setButtonColor';
import styles from "./css/contact.css";
import AIContactChat from './components/AIContactChat';

const Contact = () => {

  // setBodyColor({ background: "rgb(30 41 59)"});
  setButtonColor({ borderColor: "rgb(255 255 255 / 0.3)", color: "#fff"});

  return (
    <div>
      <Navbar />
      <div className="container-contact">
        <AIContactChat />
      </div>
    </div>
  );
};


export default Contact;